import React, { useState ,useEffect, useContext} from 'react';
import Spinner from 'react-bootstrap/Spinner';
import './LoaderBar.css';
import _ from 'lodash';
import {AppContext} from '../../Context';

export default function LoaderBar(){
    const {loader} = useContext(AppContext);

    return(
        <div className={loader.active ? "loader" : "loader close"}>
            <Spinner animation="border" role="status"></Spinner>
            <h4 className="content">{loader.content}</h4>
        </div>
    );
}